import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import styledTheme from '../../styles/theme'
import { ScreenWidthCss } from '../../styles/styled-elements'
import { openMenu } from '../../actions/MenuActions'
import { validateToken } from '../../actions/AuthActions'

import PanormaWordmark from '../../assets/panormaWordmark.svg'
import BarsSolid from '../../components/icons/BarsSolid'

const Wrapper = styled.header`
  top: 0;
  height: 70px;
  background-color: #FFF;
  position: fixed;
  z-index: 1;
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 5px #888;
  ${ScreenWidthCss}
`
const LogoDiv = styled.div`
  display: inline-flex;
  width: fit-content;
  align-items: center;
  @media (min-width: 0px) {
    padding: 10px;
  };
  @media (min-width: ${styledTheme.breakpoints.md}px) {
    padding: 20px;
  };
`
const PanormaWordmarkLogo = styled.div`
  height: 32px;
  width: 110px;
  background-image: url(${PanormaWordmark});
`
const MenuDiv = styled.div`
  height: 100%;
  display: inline-flex;
  flex: 1;
  justify-content: flex-end;
  align-items: center;
  @media (min-width: 0px) {
    padding: 10px;
  };
  @media (min-width: ${styledTheme.breakpoints.md}px) {
    padding: 20px;
  };
`
const LinkContainer = styled.div`
  display: inline-flex;
  margin-left: 30px;
  font-size: 0.875rem;
`
const HighlightLinkContainer = styled(LinkContainer)`
  a, a: link, a:active, a:visited, a:hover {
    color: red;
  }
`
const MenuIconContainer = styled.div`
  display: block;
  cursor: pointer;
  svg {
    height: 24px;
    width: 24px;
    color: ${styledTheme.colors.action_link};
  }
`

class SiteHeader extends React.Component {

  openMenuButtonClickHandler = () => {
    this.props.dispatch(openMenu())
  }

  componentDidMount() {
    const { isSignedIn, user, dispatch, routing } = this.props
    if (routing && (['/login','/logout'].indexOf(routing.location.pathname)==-1) && (!isSignedIn || !user)) {
      dispatch(push('/logout'))
    }
    if (isSignedIn) dispatch(validateToken())
  }

  componentDidUpdate() {
    const { isSignedIn, user, dispatch, routing } = this.props
    if (routing && (['/login','/logout'].indexOf(routing.location.pathname)==-1) && (!isSignedIn || !user)) {
      dispatch(push('/logout'))
    }
  }

  renderBody = (props,state) => {

    return <Wrapper>
      <LogoDiv>
        <Link to={props.isSignedIn ? '/' : '/login'}><PanormaWordmarkLogo /></Link>
      </LogoDiv>
      <MenuDiv>
       { props.isSignedIn && <MenuIconContainer onClick={this.openMenuButtonClickHandler.bind(this)}><BarsSolid /></MenuIconContainer> }
      </MenuDiv>
    </Wrapper>

  }

  render = () => this.renderBody(this.props,this.state)
}

export default connect(
  (store, props) => ({
    apiAuth: store.apiAuth,
    isSignedIn: store.apiAuth.isSignedIn,
    user: store.apiAuth.user,
    routing: store.routing,
  }),
)(SiteHeader)




// WEBPACK FOOTER //
// ./src/containers/layout/SiteHeader.js